import styled from '@emotion/styled';

export const AppContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  background-color: var(--app-background-color, transparent);
`;

export const InnerAppContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
